import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule, JsonpModule} from '@angular/http';

import {AppComponent} from './app.component';
import {StationService} from './station/station.service';
import {HistoryService} from './history/history.service';
import {ApiService} from './api/api.service';
import {StationComponent} from './station/station.component';
import {AppRoutingModule} from './routing/app-routing.module';
import {ChartComponent} from './chart/chart.component';
import {ChartService} from './chart/chart.service';
import { VideoComponent } from './video/video.component';

@NgModule({
  declarations: [
    AppComponent,
    StationComponent,
    ChartComponent,
    VideoComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    FormsModule,
    HttpModule,
    JsonpModule
  ],
  providers: [
    ApiService,
    StationService,
    HistoryService,
    ChartService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts